var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionicon = function SvgQuestionicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.5 12h-1a.5.5 0 0 0-.5.5v1c0 .28.22.5.5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Zm3.43-7.08A2.93 2.93 0 0 0 8.99 2H6.94A2.93 2.93 0 0 0 4 4.92v.51c0 .28.23.5.51.5h.78a.5.5 0 0 0 .5-.5v-.5a1.13 1.13 0 0 1 1.15-1.14H9c.63 0 1.14.5 1.14 1.13v.57c0 .5-.31.93-.78 1.09l-.97.31c-.78.26-1.31.99-1.31 1.81v.8c0 .27.22.5.5.5h.78a.5.5 0 0 0 .51-.5v-.8c0-.06.06-.12.13-.12l.97-.32A2.94 2.94 0 0 0 12 5.5l-.07-.57Z"
  })));
};
export default SvgQuestionicon;